export const isBrowser = () => typeof window !== "undefined"

export const getUser = () =>
  isBrowser() && window.localStorage.getItem("npbUser")
    ? JSON.parse(window.localStorage.getItem("npbUser"))
    : {}

export const setUser = (user: {
  cognitoID?: string;
  courses?: {};
  firstName: string;
  lastName: string;
}) =>
  window.localStorage.setItem("npbUser", JSON.stringify(user))
